"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ApiOrder {
}
exports.default = ApiOrder;
//# sourceMappingURL=ApiOrder.js.map